import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Copy, ExternalLink } from 'lucide-react';
import PropTypes from 'prop-types';
import DynamicTooltip from 'components/atoms/dynamicTooltip';
import { Loader } from '@getro/rombo';

export const JobApplicationDetail = ({ label, value, isLink, isExternal, onCopy, copyText, isLoading, onClick }) => {
  const handleClick = () => {
    if (isLink && value) {
      if (isExternal) {
        window.open(value, '_blank');
      } else if (onCopy) {
        onCopy();
      }
    }
  };

  return (
    <Flex
      sx={{
        alignItems: 'flex-start',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '140%',
        gap: '8px',
      }}
    >
      <Text sx={{ flexShrink: 0, width: '160px', color: 'text.subtle' }}>{label}</Text>
      <Flex alignItems="center" sx={{ gap: '8px' }}>
        <Text fontSize="14px" color="text.main" lineHeight="1.4">
          {value || '-'}
        </Text>
        {isLink && value && !isLoading && (
          <Box
            width="14px"
            height="14px"
            onClick={onClick ?? handleClick}
            sx={{ cursor: 'pointer', color: 'text.secondary' }}
          >
            {isExternal ? (
              <ExternalLink size={14} />
            ) : (
              <DynamicTooltip content={copyText} trigger={<Copy size={14} />} useTooltip={Boolean(copyText)} />
            )}
          </Box>
        )}

        {isLoading && <Loader size="small" />}
      </Flex>
    </Flex>
  );
};

JobApplicationDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isLink: PropTypes.bool.isRequired,
  isExternal: PropTypes.bool.isRequired,
  onCopy: PropTypes.func,
  copyText: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
};

JobApplicationDetail.defaultProps = {
  copyText: '',
  onCopy: () => {},
  isLoading: false,
  onClick: null,
};
